'use client'

import { FC, useMemo } from 'react'
import { FormDropdown, Option } from '@/root/modules/shared/SelectTicketPage/components/PassengerForm'
import { CountryOption } from '@/root/modules/shared/SelectTicketPage/helpers/countries/countries'

interface CitizenshipSelectProps {
  value: string
  options: CountryOption[]
  onChange: (value: string) => void
  placeholder?: string
  searchPlaceholder?: string
  disabled?: boolean
}

export const CitizenshipSelect: FC<CitizenshipSelectProps> = ({
  value,
  options,
  onChange,
  placeholder,
  searchPlaceholder,
  disabled,
}) => {
  const dropdownOptions: Option[] = useMemo(
    () => options.map((o) => (o.type === 'separator' ? o : { value: o.value, label: o.label })),
    [options]
  )

  return (
    <FormDropdown
      value={value}
      onChange={(v) => onChange(String(v))}
      options={dropdownOptions}
      placeholder={placeholder}
      searchable={true}
      className="w-44 md:w-56"
      searchPlaceholder={searchPlaceholder}
      disabled={disabled}
    />
  )
}
